import { Box, Pagination } from "@mui/material"

const paginationSx = {
    "& .MuiPaginationItem-root": {
        fontWeight: 600,
    },
    "& .Mui-selected": {
        bgcolor: "#000435 !important",
        color: "#fff",
    },
}

const StyledPagination = ({ count, page, onChange }) => (
    <Box display="flex" justifyContent="center" mt={5}>
        <Pagination color="primary" count={count} page={page} onChange={onChange} sx={paginationSx} />
    </Box>
)

export default StyledPagination
